<template>
    <section class="appointment-page">
        <header class="appointment-heading">
            <div>

                <h2>摄影预约</h2>

            </div>
            <button type="button" class="refresh-button" :disabled="isLoading" @click="loadAppointments()">
                {{ isLoading ? "刷新中…" : "刷新状态" }}
            </button>
        </header>

        <nav class="appointment-tabs" aria-label="摄影预约状态">
            <button
                v-for="tab in tabs"
                :key="tab.key"
                type="button"
                :class="{ active: group === tab.key }"
                :aria-pressed="group === tab.key"
                @click="selectGroup(tab.key)">
                {{ tab.label }}
            </button>
        </nav>

        <details class="filter-disclosure"><summary><img src="@/assets/images/appointments/d70dd.svg" alt="" />筛选</summary><div class="date-filter">
            <label>创建日期 <input v-model="startDate" type="date" /></label>
            <span>至</span>
            <label><span class="sr-only">结束日期</span><input v-model="endDate" type="date" /></label>
            <button type="button" @click="applyDates">筛选</button>
            <button type="button" class="quiet" @click="clearDates">重置</button>
        </div>

        </details>
        <div v-if="state.status === 'error'" class="state-panel state-panel--error">
            <strong>预约加载失败</strong><span>{{ state.error }}</span>
            <button type="button" @click="loadAppointments()">重新加载</button>
        </div>
        <div v-else-if="isLoading && !state.items.length" class="state-panel">正在获取最新预约…</div>
        <div v-else-if="state.status === 'empty'" class="state-panel">
            <img class="empty-camera" src="@/assets/images/appointments/2eb8c.svg" alt="" /><strong>暂无该状态的摄影预约</strong>
        </div>

        <div v-else class="appointment-grid">
            <article v-for="appointment in state.items" :key="appointment.appointmentNo" class="appointment-card">
                <header><div><h3>{{ appointment.themeName || "摄影预约" }} · {{ appointment.styleName || "风格待确认" }}</h3><time>{{ formatDateTime(appointment.createdAt) }}</time></div><span class="status-chip" :class="statusClass(appointment.status)">{{ appointment.statusText }}</span></header>
                <div class="appointment-meta">
                    <p><span>套餐：</span><strong>{{ appointment.packageName || "套餐信息待确认" }}</strong></p>
                    <p><span>预约时间：</span><strong>{{ formatDateTime(appointment.shootAt) || "时间待确认" }}</strong></p>
                </div>

                <div class="list-facts">
                    <p><span>拍摄地点</span><strong>{{ [appointment.venueName, appointment.pointName].filter(Boolean).join(' · ') || '地点待确认' }}</strong><small v-if="appointment.venueLocationSummary">{{ appointment.venueLocationSummary }}</small></p>
                    <p><span>拍摄人数</span><strong>{{ appointment.peopleCount == null ? '人数待确认' : appointment.peopleCount + ' 人' }}</strong></p>
                    <p v-if="appointment.photographyServiceStatusText"><span>摄影服务</span><strong>{{ appointment.photographyServiceStatusText }}</strong></p>
                    <p v-if="appointment.makeupSelected"><span>化妆服务</span><strong>{{ appointment.makeupServiceStatusText || '状态待确认' }}</strong></p>
                </div>

                <footer>
                    <span class="money-hint">{{ paymentHint(appointment) }}</span>
                    <div class="card-actions">
                        <button
                            v-for="action in appointment.actions"
                            :key="`${action.code}-${action.targetResourceType}-${action.targetResourceId}`"
                            type="button"
                            @click="openDetail(appointment.appointmentNo, action)">
                            {{ action.label }}
                        </button>
                        <button type="button" class="detail-button" @click="openDetail(appointment.appointmentNo)">查看订单</button>
                    </div>
                </footer>
            </article>
        </div>

        <el-pagination
            v-if="state.total > state.pageSize"
            background
            layout="prev, pager, next"
            :current-page="state.pageNo"
            :page-size="state.pageSize"
            :total="state.total"
            @current-change="changePage" />
    </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import photographyAppointments from "@/tool/photographyAppointments.cjs";

const { formatAppointmentDateTime, getAppointmentRefundStatusText } = photographyAppointments;

export default {
    name: "PhotographyAppointments",
    data() {
        return {
            group: "all",
            startDate: "",
            endDate: "",
            failedProviderPhotoUrls: {},
            tabs: [
                { key: "all", label: "全部" },
                { key: "payment", label: "待支付" },
                { key: "matching", label: "匹配中" },
                { key: "fulfillment", label: "待履约" },
                { key: "active", label: "进行中" },
                { key: "ended", label: "已结束" },
            ],
        };
    },
    computed: {
        ...mapState({ state: (state) => state.photographyAppointments }),
        isLoading() { return this.state.status === "loading"; },
    },
    watch: {
        "$store.state.user.user_id"() { this.$store.commit("clearPhotographyAppointmentsList"); this.loadAppointments(1); },
    },
    beforeDestroy() { this.$store.commit("clearPhotographyAppointmentsList"); },
    mounted() {
        this.loadAppointments();
    },
    methods: {
        ...mapActions(["loadPhotographyAppointments"]),
        loadAppointments(pageNo = this.state.pageNo || 1) {

            return this.loadPhotographyAppointments({
                group: this.group,
                startDate: this.startDate,
                endDate: this.endDate,
                pageNo,
                pageSize: 8,
            }).catch(() => {});
        },
        selectGroup(group) { this.group = group; this.loadAppointments(1); },
        applyDates() { this.loadAppointments(1); },
        clearDates() { this.startDate = ""; this.endDate = ""; this.loadAppointments(1); },
        changePage(pageNo) { this.loadAppointments(pageNo); },
        openDetail(appointmentNo, action = null) {
            const query = action ? { action: action.code, targetResourceType: action.targetResourceType, targetResourceId: action.targetResourceId } : {};
            this.$router.push({ name: "photographyAppointmentDetail", params: { appointmentNo }, query });
        },
        formatDateTime: formatAppointmentDateTime,
        providerRoleName(service) { return service.serviceType === "MAKEUP" ? "化妆师" : "摄影师"; },
        providerPhotoUrl(service) {
            const photo = service.currentProvider && service.currentProvider.personalPhoto;
            return photo && !this.failedProviderPhotoUrls[photo.accessUrl] ? photo.accessUrl : "";
        },
        handleProviderPhotoError(service) {
            const url = this.providerPhotoUrl(service);
            if (!url) return;
            this.failedProviderPhotoUrls = { ...this.failedProviderPhotoUrls, [url]: true };
            this.loadAppointments();
        },
        statusClass(status) { return `status-${String(status || "unknown").toLowerCase().replace(/_/g, "-")}`; },
        paymentHint(appointment) {
            if (appointment.refundStatus) return getAppointmentRefundStatusText(appointment.refundStatus);
            return appointment.paymentHint || `应付 ¥${appointment.payableAmount}`;
        },
    },
};
</script>

<style scoped>
.appointment-page { color:#24242a; position:relative; }
.appointment-heading { display:flex; align-items:center; justify-content:space-between; margin:0 0 18px; }.appointment-heading h2 { margin:0; font-size:26px; line-height:1.4; }
.appointment-tabs { display:flex; gap:30px; padding:30px 32px 0; border-radius:24px 24px 0 0; background:white; overflow-x:auto; }.appointment-tabs button { padding:4px 0 20px; border:0; border-bottom:2px solid transparent; background:white; color:#777780; font-size:14px; white-space:nowrap; cursor:pointer; }.appointment-tabs button.active { border-bottom-color:#6b5dd5; color:#6b5dd5; font-weight:700; }
.filter-disclosure { padding:0 32px; background:white; }.filter-disclosure summary { width:max-content; margin-left:auto; display:flex; gap:6px; align-items:center; padding:10px 0; color:#6b5dd5; font-size:14px; cursor:pointer; }.filter-disclosure summary img { width:16px; height:16px; }.date-filter { display:flex; flex-wrap:wrap; gap:10px; align-items:center; padding:12px 0 20px; font-size:13px; }.date-filter label { display:flex; gap:8px; align-items:center; }.date-filter input { min-width:0; max-width:100%; height:36px; border:1px solid #e9e9ef; border-radius:8px; padding:0 8px; color:#24242a; }
.appointment-grid { display:grid; grid-template-columns:1fr; min-height:460px; align-content:start; padding:0 32px 32px; background:white; border-radius:0 0 24px 24px; gap:0; }.appointment-card { display:grid; grid-template-columns:minmax(0,1fr) minmax(0,1fr) 180px; gap:20px; padding:22px 0 24px; border-top:1px solid #e9e9ef; }.appointment-card > header { grid-column:1/-1; display:flex; justify-content:space-between; align-items:center; gap:12px; }.appointment-card time { font-size:12px; color:#777780; }.status-chip { display:inline-block; background:#f0edfd; color:#6b5dd5; padding:4px 10px; border-radius:6px; font-size:12px; }.appointment-card h3 { margin:12px 0 20px; font-size:17px; line-height:26px; }.appointment-meta { grid-column:2; grid-row:2; }.list-facts { grid-column:1; grid-row:2; }.appointment-meta,.list-facts { display:grid; grid-template-columns:1fr; column-gap:32px; row-gap:12px; margin-bottom:16px; }.appointment-meta p,.list-facts p { margin:0; min-width:0; }.appointment-meta span,.list-facts span { display:block; color:#777780; font-size:12px; margin-bottom:8px; }.appointment-meta strong,.list-facts strong { font-weight:400; font-size:14px; overflow-wrap:anywhere; }.list-facts small { display:block; color:#777780; margin-top:5px; }.appointment-card footer { grid-column:3; grid-row:2; display:flex; flex-direction:column; justify-content:space-between; align-items:flex-end; gap:16px; }.money-hint { font-size:18px; font-weight:700; }.card-actions { display:flex; flex-wrap:wrap; gap:8px; justify-content:flex-end; }button { cursor:pointer; }.card-actions button,.refresh-button,.date-filter button { padding:10px 18px; border:1px solid #e9e9ef; border-radius:100px; background:white; color:#24242a; }.card-actions .detail-button { color:#6b5dd5; }.refresh-button { font-size:12px; }.date-filter button { color:#6b5dd5; }.state-panel { display:grid; gap:22px; min-height:460px; box-sizing:border-box; justify-items:center; align-content:center; padding:32px; color:#777780; font-size:14px; background:white; border-radius:0 0 24px 24px; text-align:center; }.state-panel strong { font-weight:400; }.state-panel--error { color:#ac424d; }.empty-camera { width:72px; height:72px; }.el-pagination { margin:24px 0; text-align:center; }button:focus-visible,summary:focus-visible,input:focus-visible { outline:2px solid #6b5dd5; outline-offset:3px; }button:disabled { opacity:.6; cursor:wait; }.sr-only { position:absolute; width:1px; height:1px; overflow:hidden; clip:rect(0,0,0,0); }
@media(max-width:700px) { .appointment-card { display:block; }.appointment-card > header { margin-bottom:20px; }.appointment-meta,.list-facts { display:grid; grid-template-columns:1fr 1fr; }.list-facts { margin:20px 0; } .appointment-tabs { padding:24px 16px 0; gap:24px; }.appointment-grid { padding:0 16px 24px; }.filter-disclosure { padding:0 16px; }.appointment-heading h2 { font-size:22px; }.appointment-meta,.list-facts { column-gap:16px; }.appointment-card footer { align-items:flex-start; flex-direction:column; }.money-hint { font-size:18px; }.date-filter input { width:135px; height:44px; }.filter-disclosure summary { min-height:44px; box-sizing:border-box; }.refresh-button { padding:9px 12px; } }
</style>
